import React from 'react';
import { Breadcrumb, Typography } from 'antd';
import { HomeOutlined, FileTextOutlined } from '@ant-design/icons';
import { theme } from '../../../theme';

const { Text } = Typography;

interface ContratoFormHeaderProps {
  formProgress: number;
}

export const ContratoFormHeader: React.FC<ContratoFormHeaderProps> = ({ formProgress }) => {
  return (
    <>
      <Breadcrumb
        style={{ marginBottom: '16px' }}
        items={[
          {
            href: '/',
            title: (
              <>
                <HomeOutlined />
                <span style={{ marginLeft: '4px' }}>Inicio</span>
              </>
            ),
          },
          {
            href: '/listadocontratos',
            title: 'Contratos',
          },
          {
            title: (
              <>
                <FileTextOutlined />
                <span style={{ marginLeft: '4px' }}>Nuevo Contrato</span>
              </>
            ),
          },
        ]}
      />

      {/* Título de la página */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <h1 style={{ 
          color: theme.colors.primaryDark, 
          fontSize: '28px', 
          fontWeight: 600, 
          margin: 0
        }}>
          Nuevo Contrato
        </h1>
        
        {/* Indicador de progreso */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '8px 16px',
          backgroundColor: theme.colors.backgroundGray,
          borderRadius: '8px',
          border: `1px solid ${theme.colors.borderLight}`
        }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Progreso:</Text>
          <div style={{
            width: '120px',
            height: '8px',
            backgroundColor: '#e5e7eb',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${formProgress}%`,
              height: '100%',
              backgroundColor: formProgress === 100 ? '#52c41a' : theme.colors.primary,
              transition: 'width 0.3s ease'
            }} />
          </div>
          <Text strong style={{ fontSize: '12px', color: theme.colors.textPrimary, minWidth: '35px' }}>
            {formProgress}%
          </Text>
        </div>
      </div>
    </>
  );
};

